var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchBroEon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 399,
    fill: "none",
    viewBox: "0 0 486 399",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m54.81 79.582c-18.766 25.228-30.833 62.297-21.682 93.344 15.637 53.062 81.991 57.06 127.44 63.201 31.321 4.236 62.463 28.857 89.25 44.137 35.7 20.373 93.129 52.515 134.3 31.642 34.13-17.291 52.479-59.119 62.951-93.82 16.41-54.335 17.993-119.88-17.731-167.22-48.623-64.26-133.68-53.55-204.36-42.554-47.303 7.3661-93.285 14.542-135.34 39.615-13.578 8.1598-25.414 18.916-34.831 31.654z",
    fill: "#FFC933",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 382.75c0 4.236 108.66 7.675 242.76 7.675s242.76-3.439 242.76-7.675c0-4.237-108.66-7.676-242.7-7.676-134.04 0-242.82 3.439-242.82 7.676z",
    fill: "#FFC933",
    style: {
      fill: "#ffb6ae",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 382.75c0 4.236 108.66 7.675 242.76 7.675s242.76-3.439 242.76-7.675c0-4.237-108.66-7.676-242.7-7.676-134.04 0-242.82 3.439-242.82 7.676z",
    fill: "white",
    opacity: 0.6,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m270.16 2.5537h-215.57v273.44h215.57v-273.44z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m270.16 2.5537h-215.57v16.315h215.57v-16.315z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    d: "m97.164 193.26h-36.438v77.338h36.438v-77.338z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.164 193.26h-36.438v77.338h36.438v-77.338z",
    fill: "white",
    opacity: 0.6,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.9 193.26h-36.438v77.338h36.438v-77.338z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.9 193.26h-36.438v77.338h36.438v-77.338z",
    fill: "white",
    opacity: 0.6,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.12 193.26h-36.437v77.338h36.437v-77.338z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.12 193.26h-36.437v77.338h36.437v-77.338z",
    fill: "white",
    opacity: 0.6,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.33 193.26h-36.437v77.338h36.437v-77.338z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.33 193.26h-36.437v77.338h36.437v-77.338z",
    fill: "white",
    opacity: 0.6,
    style: {
      fill: "none"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m264.57 193.26h-36.438v77.338h36.438v-77.338z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    d: "m263.99 9.0034h-203.25v18.742h203.25v-18.742z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.99 9.0034h-203.25v18.742h203.25v-18.742z",
    fill: "white",
    opacity: 0.6,
    style: {
      fill: "none"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m261.13 12.645h-196.74v8.2943h196.74v-8.2943z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m261.12 12.645h-22.277v8.2943h22.277v-8.2943z",
    fill: "#FFC933",
    stroke: "#FFC933",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    style: {
      fill: "#c73b24"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m151.2 44.549h-41.65c-.426 0-.835-.1692-1.136-.4705s-.471-.7099-.471-1.136c0-.426.17-.8346.471-1.1359s.71-.4706 1.136-.4706h41.65c.426 0 .835.1693 1.136.4706s.47.7099.47 1.1359c0 .4261-.169.8347-.47 1.136s-.71.4705-1.136.4705z",
    fill: "#353535"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m151.2 55.747h-41.65c-.222.0191-.445-.008-.656-.0798-.21-.0717-.404-.1865-.568-.337-.164-.1504-.295-.3334-.385-.5372-.089-.2038-.135-.4239-.135-.6465 0-.2227.046-.4428.135-.6466.09-.2038.221-.3868.385-.5373.164-.1504.358-.2652.568-.3369.211-.0718.434-.0989.656-.0798h41.65c.401.0346.774.2182 1.046.5145.272.2964.423.6839.423 1.0861 0 .4021-.151.7896-.423 1.086-.272.2963-.645.4799-1.046.5145z",
    fill: "#353535"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m151.2 66.957h-41.65c-.426 0-.835-.1693-1.136-.4706s-.471-.7099-.471-1.136c0-.426.17-.8346.471-1.1359s.71-.4705 1.136-.4705h41.65c.426 0 .835.1692 1.136.4705s.47.7099.47 1.1359c0 .4261-.169.8347-.47 1.136s-.71.4706-1.136.4706z",
    fill: "#353535"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m151.2 78.155h-86.442c-.4007-.0346-.7738-.2182-1.0457-.5145s-.4227-.6839-.4227-1.086c0-.4022.1508-.7897.4227-1.0861.2719-.2963.645-.4799 1.0457-.5145h86.442c.401.0346.774.2182 1.046.5145.272.2964.422.6839.422 1.0861 0 .4021-.15.7897-.422 1.086s-.645.4799-1.046.5145z",
    fill: "#353535"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m151.2 89.364h-86.441c-.4261 0-.8347-.1693-1.136-.4706-.3013-.3012-.4705-.7099-.4705-1.1359 0-.4261.1692-.8347.4705-1.136s.7099-.4705 1.136-.4705h86.441c.427 0 .835.1692 1.136.4705.302.3013.471.7099.471 1.136 0 .426-.169.8347-.471 1.1359-.301.3013-.709.4706-1.136.4706z",
    fill: "#353535"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m151.2 100.57h-86.441c-.4261 0-.8347-.169-1.136-.47-.3013-.3015-.4705-.7101-.4705-1.1362s.1692-.8347.4705-1.1359c.3013-.3013.7099-.4706 1.136-.4706h86.441c.427 0 .835.1693 1.136.4706.302.3012.471.7098.471 1.1359s-.169.8347-.471 1.1362c-.301.301-.709.47-1.136.47z",
    fill: "#353535"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m151.2 111.77h-86.442c-.4007-.035-.7738-.218-1.0457-.515-.2719-.296-.4227-.683-.4227-1.086 0-.402.1508-.789.4227-1.086.2719-.296.645-.48 1.0457-.514h86.442c.401.034.774.218 1.046.514.272.297.422.684.422 1.086 0 .403-.15.79-.422 1.086-.272.297-.645.48-1.046.515z",
    fill: "#353535"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m151.2 121.73h-86.442c-.4007-.034-.7738-.218-1.0457-.514-.2719-.297-.4227-.684-.4227-1.086s.1508-.79.4227-1.086c.2719-.297.645-.48 1.0457-.515h86.442c.401.035.774.218 1.046.515.272.296.422.684.422 1.086s-.15.789-.422 1.086c-.272.296-.645.48-1.046.514z",
    fill: "#353535"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m151.2 132.98h-86.441c-.4261 0-.8347-.17-1.136-.471s-.4705-.71-.4705-1.136.1692-.835.4705-1.136.7099-.47 1.136-.47h86.441c.427 0 .835.169 1.136.47.302.301.471.71.471 1.136s-.169.835-.471 1.136c-.301.301-.709.471-1.136.471z",
    fill: "#353535"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m151.2 144.14h-86.442c-.4007-.035-.7738-.218-1.0457-.514-.2719-.297-.4227-.684-.4227-1.086 0-.403.1508-.79.4227-1.087.2719-.296.645-.479 1.0457-.514h86.442c.401.035.774.218 1.046.514.272.297.422.684.422 1.087 0 .402-.15.789-.422 1.086-.272.296-.645.479-1.046.514z",
    fill: "#353535"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m151.2 155.35h-86.441c-.4261 0-.8347-.17-1.136-.471s-.4705-.71-.4705-1.136.1692-.834.4705-1.136c.3013-.301.7099-.47 1.136-.47h86.441c.427 0 .835.169 1.136.47.302.302.471.71.471 1.136s-.169.835-.471 1.136c-.301.301-.709.471-1.136.471z",
    fill: "#353535"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m151.2 166.55h-86.442c-.4007-.035-.7738-.218-1.0457-.515-.2719-.296-.4227-.684-.4227-1.086s.1508-.789.4227-1.086c.2719-.296.645-.48 1.0457-.514h86.442c.401.034.774.218 1.046.514.272.297.422.684.422 1.086s-.15.79-.422 1.086c-.272.297-.645.48-1.046.515z",
    fill: "#353535"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m151.2 177.76h-86.442c-.4007-.034-.7738-.218-1.0457-.514-.2719-.297-.4227-.684-.4227-1.086s.1508-.79.4227-1.086c.2719-.297.645-.48 1.0457-.515h86.442c.401.035.774.218 1.046.515.272.296.422.684.422 1.086s-.15.789-.422 1.086c-.272.296-.645.48-1.046.514z",
    fill: "#353535"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m262.47 44.549h-86.406c-.426 0-.835-.1692-1.136-.4705-.302-.3013-.471-.7099-.471-1.136 0-.426.169-.8346.471-1.1359.301-.3013.71-.4706 1.136-.4706h86.406c.426 0 .834.1693 1.135.4706.302.3013.471.7099.471 1.1359 0 .4261-.169.8347-.471 1.136-.301.3013-.709.4705-1.135.4705z",
    fill: "#353535"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m262.47 55.747h-86.406c-.222.0191-.445-.008-.656-.0798-.211-.0717-.404-.1865-.568-.337-.164-.1504-.295-.3334-.385-.5372-.089-.2038-.136-.4239-.136-.6465 0-.2227.047-.4428.136-.6466.09-.2038.221-.3868.385-.5373.164-.1504.357-.2652.568-.3369.211-.0718.434-.0989.656-.0798h86.406c.222-.0191.445.008.656.0798.211.0717.404.1865.568.3369.164.1505.295.3335.385.5373.089.2038.136.4239.136.6466 0 .2226-.047.4427-.136.6465-.09.2038-.221.3868-.385.5372-.164.1505-.357.2653-.568.337-.211.0718-.434.0989-.656.0798z",
    fill: "#353535"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m262.47 66.957h-86.406c-.426 0-.835-.1693-1.136-.4706-.302-.3013-.471-.7099-.471-1.136 0-.426.169-.8346.471-1.1359.301-.3013.71-.4705 1.136-.4705h86.406c.426 0 .834.1692 1.135.4705.302.3013.471.7099.471 1.1359 0 .4261-.169.8347-.471 1.136-.301.3013-.709.4706-1.135.4706z",
    fill: "#353535"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m262.47 78.154h-86.406c-.222.0191-.445-.008-.656-.0797-.211-.0718-.404-.1865-.568-.337s-.295-.3335-.385-.5373c-.089-.2037-.136-.4239-.136-.6465s.047-.4428.136-.6466c.09-.2038.221-.3867.385-.5372s.357-.2653.568-.337c.211-.0718.434-.0989.656-.0798h86.406c.222-.0191.445.008.656.0798.211.0717.404.1865.568.337s.295.3334.385.5372c.089.2038.136.424.136.6466s-.047.4428-.136.6465c-.09.2038-.221.3868-.385.5373s-.357.2652-.568.337c-.211.0717-.434.0988-.656.0797z",
    fill: "#353535"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m262.47 89.364h-86.406c-.426 0-.835-.1693-1.136-.4706-.302-.3012-.471-.7099-.471-1.1359 0-.4261.169-.8347.471-1.136.301-.3013.71-.4705 1.136-.4705h86.406c.426 0 .834.1692 1.135.4705.302.3013.471.7099.471 1.136 0 .426-.169.8347-.471 1.1359-.301.3013-.709.4706-1.135.4706z",
    fill: "#353535"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m262.47 100.57h-86.406c-.211 0-.42-.041-.615-.122s-.372-.199-.521-.348c-.15-.1494-.268-.3265-.349-.5214-.08-.1949-.122-.4038-.122-.6148s.042-.4198.122-.6148c.081-.1949.199-.372.349-.5211.149-.1492.326-.2676.521-.3483s.404-.1223.615-.1223h86.406c.21 0 .419.0416.614.1223s.372.1991.521.3483c.15.1491.268.3262.349.5211.08.195.122.4038.122.6148s-.042.4199-.122.6148c-.081.1949-.199.372-.349.5214-.149.149-.326.267-.521.348s-.404.122-.614.122z",
    fill: "#353535"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m262.47 111.77h-86.406c-.222.019-.445-.008-.656-.08s-.404-.186-.568-.337c-.164-.15-.295-.333-.385-.537-.089-.204-.136-.424-.136-.647 0-.222.047-.442.136-.646.09-.204.221-.387.385-.537.164-.151.357-.266.568-.337.211-.072.434-.099.656-.08h86.406c.222-.019.445.008.656.08.211.071.404.186.568.337.164.15.295.333.385.537.089.204.136.424.136.646 0 .223-.047.443-.136.647-.09.204-.221.387-.385.537-.164.151-.357.265-.568.337s-.434.099-.656.08z",
    fill: "#353535"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m264.02 119.3h-88.06v61.416h88.06v-61.416z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.02 119.3h-88.06v61.416h88.06v-61.416z",
    fill: "white",
    opacity: 0.6,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.8 34.684h-89.75v240.75h89.75v-240.75z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.8 34.684h-89.75v240.75h89.75v-240.75z",
    fill: "white",
    opacity: 0.4,
    style: {
      fill: "none"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m427.33 25.675h-215.57v273.44h215.57v-273.44z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m427.33 25.675h-215.57v16.315h215.57v-16.315z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    d: "m360.07 64.398h-75.696v141.5h75.696v-141.5z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.07 64.398h-75.696v141.5h75.696v-141.5z",
    fill: "white",
    opacity: 0.6,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.18 216.37h-203.25v77.338h203.25v-77.338z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.18 216.37h-203.25v77.338h203.25v-77.338z",
    fill: "white",
    opacity: 0.6,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.18 32.125h-203.25v18.742h203.25v-18.742z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.18 32.125h-203.25v18.742h203.25v-18.742z",
    fill: "white",
    opacity: 0.6,
    style: {
      fill: "none"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m418.32 35.767h-196.74v8.2943h196.74v-8.2943z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m418.31 35.767h-22.277v8.2943h22.277v-8.2943z",
    fill: "#FFC933",
    stroke: "#FFC933",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    style: {
      fill: "#c73b24"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 67.659h-51.872c-.222.0192-.445-.008-.656-.0798-.211-.0717-.404-.1864-.568-.3369s-.295-.3335-.385-.5373c-.09-.2037-.136-.4239-.136-.6465 0-.2227.046-.4428.136-.6466s.221-.3867.385-.5372.357-.2653.568-.337c.211-.0718.434-.0989.656-.0798h51.872c.222-.0191.445.008.656.0798.21.0717.404.1865.568.337s.295.3334.385.5372c.089.2038.136.4239.136.6466 0 .2226-.047.4428-.136.6465-.09.2038-.221.3868-.385.5373s-.358.2652-.568.3369c-.211.0718-.434.099-.656.0798z",
    fill: "#353535"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 78.868h-51.872c-.426 0-.834-.1693-1.136-.4706-.301-.3012-.47-.7099-.47-1.1359 0-.4261.169-.8347.47-1.136.302-.3013.71-.4705 1.136-.4705h51.872c.426 0 .835.1692 1.136.4705.302.3013.471.7099.471 1.136 0 .426-.169.8347-.471 1.1359-.301.3013-.71.4706-1.136.4706z",
    fill: "#353535"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 90.066h-51.872c-.222.0192-.445-.008-.656-.0797-.211-.0718-.404-.1865-.568-.337s-.295-.3335-.385-.5372c-.09-.2038-.136-.424-.136-.6466s.046-.4428.136-.6466.221-.3867.385-.5372.357-.2653.568-.337.434-.0989.656-.0798h51.872c.222-.0191.445.0081.656.0798.21.0717.404.1865.568.337s.295.3334.385.5372c.089.2038.136.424.136.6466s-.047.4428-.136.6466c-.09.2037-.221.3867-.385.5372s-.358.2652-.568.337c-.211.0717-.434.0989-.656.0797z",
    fill: "#353535"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 101.28h-51.872c-.211 0-.42-.042-.615-.122-.194-.081-.372-.199-.521-.349-.149-.149-.267-.326-.348-.521s-.122-.4036-.122-.6145c0-.211.041-.4199.122-.6148s.199-.372.348-.5212.327-.2675.521-.3482c.195-.0808.404-.1223.615-.1223h51.872c.426 0 .835.1692 1.136.4705.302.3013.471.7099.471 1.136 0 .4265-.169.8345-.471 1.1355-.301.302-.71.471-1.136.471z",
    fill: "#353535"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 112.47h-51.872c-.222.019-.445-.008-.656-.08-.211-.071-.404-.186-.568-.337-.164-.15-.295-.333-.385-.537s-.136-.424-.136-.646c0-.223.046-.443.136-.647s.221-.387.385-.537c.164-.151.357-.265.568-.337s.434-.099.656-.08h51.872c.222-.019.445.008.656.08.21.072.404.186.568.337.164.15.295.333.385.537.089.204.136.424.136.647 0 .222-.047.442-.136.646-.09.204-.221.387-.385.537-.164.151-.358.266-.568.337-.211.072-.434.099-.656.08z",
    fill: "#353535"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 123.68h-51.872c-.222.019-.445-.008-.656-.08-.211-.071-.404-.186-.568-.337-.164-.15-.295-.333-.385-.537s-.136-.424-.136-.646c0-.223.046-.443.136-.647s.221-.387.385-.537c.164-.151.357-.265.568-.337s.434-.099.656-.08h51.872c.222-.019.445.008.656.08.21.072.404.186.568.337.164.15.295.333.385.537.089.204.136.424.136.647 0 .222-.047.442-.136.646-.09.204-.221.387-.385.537-.164.151-.358.266-.568.337-.211.072-.434.099-.656.08z",
    fill: "#353535"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 134.89h-51.872c-.211 0-.42-.042-.615-.123-.194-.08-.372-.199-.521-.348s-.267-.326-.348-.521-.122-.404-.122-.615.041-.42.122-.615.199-.372.348-.521.327-.267.521-.348c.195-.081.404-.122.615-.122h51.872c.426 0 .835.169 1.136.47.302.301.471.71.471 1.136s-.169.835-.471 1.136c-.301.301-.71.471-1.136.471z",
    fill: "#353535"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 144.88h-51.872c-.426 0-.834-.169-1.136-.47-.301-.302-.47-.71-.47-1.136 0-.427.169-.835.47-1.136.302-.302.71-.471 1.136-.471h51.872c.426 0 .835.169 1.136.471.302.301.471.709.471 1.136 0 .426-.169.834-.471 1.136-.301.301-.71.47-1.136.47z",
    fill: "#353535"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 156.05h-51.872c-.222.019-.445-.008-.656-.08s-.404-.186-.568-.337c-.164-.15-.295-.333-.385-.537s-.136-.424-.136-.647c0-.222.046-.443.136-.646.09-.204.221-.387.385-.538.164-.15.357-.265.568-.337.211-.071.434-.098.656-.079h51.872c.222-.019.445.008.656.079.21.072.404.187.568.337.164.151.295.334.385.538.089.203.136.424.136.646 0 .223-.047.443-.136.647-.09.204-.221.387-.385.537-.164.151-.358.265-.568.337-.211.072-.434.099-.656.08z",
    fill: "#353535"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 167.26h-51.872c-.426 0-.834-.169-1.136-.471-.301-.301-.47-.71-.47-1.136s.169-.834.47-1.136c.302-.301.71-.47 1.136-.47h51.872c.426 0 .835.169 1.136.47.302.302.471.71.471 1.136s-.169.835-.471 1.136c-.301.302-.71.471-1.136.471z",
    fill: "#353535"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 178.46h-51.872c-.222.02-.445-.008-.656-.079-.211-.072-.404-.187-.568-.337-.164-.151-.295-.334-.385-.537-.09-.204-.136-.424-.136-.647s.046-.443.136-.647c.09-.203.221-.386.385-.537.164-.15.357-.265.568-.337s.434-.099.656-.08h51.872c.222-.019.445.008.656.08.21.072.404.187.568.337.164.151.295.334.385.537.089.204.136.424.136.647s-.047.443-.136.647c-.09.203-.221.386-.385.537-.164.15-.358.265-.568.337-.211.071-.434.099-.656.079z",
    fill: "#353535"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 189.67h-51.872c-.426 0-.834-.17-1.136-.471-.301-.301-.47-.71-.47-1.136s.169-.835.47-1.136c.302-.301.71-.47 1.136-.47h51.872c.426 0 .835.169 1.136.47.302.301.471.71.471 1.136s-.169.835-.471 1.136c-.301.301-.71.471-1.136.471z",
    fill: "#353535"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 200.87h-51.872c-.222.019-.445-.008-.656-.08-.211-.071-.404-.186-.568-.337-.164-.15-.295-.333-.385-.537s-.136-.424-.136-.646c0-.223.046-.443.136-.647s.221-.387.385-.537c.164-.151.357-.265.568-.337s.434-.099.656-.08h51.872c.222-.019.445.008.656.08.21.072.404.186.568.337.164.15.295.333.385.537.089.204.136.424.136.647 0 .222-.047.442-.136.646-.09.204-.221.387-.385.537-.164.151-.358.266-.568.337-.211.072-.434.099-.656.08z",
    fill: "#353535"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m271.65 212.08h-51.872c-.222.019-.445-.008-.656-.08-.211-.071-.404-.186-.568-.337-.164-.15-.295-.333-.385-.537s-.136-.424-.136-.646c0-.223.046-.443.136-.647s.221-.387.385-.537c.164-.151.357-.265.568-.337s.434-.099.656-.08h51.872c.222-.019.445.008.656.08.21.072.404.186.568.337.164.15.295.333.385.537.089.204.136.424.136.647 0 .222-.047.442-.136.646-.09.204-.221.387-.385.537-.164.151-.358.266-.568.337-.211.072-.434.099-.656.08z",
    fill: "#353535"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m420.79 67.659h-51.813c-.222.0192-.445-.008-.656-.0798-.21-.0717-.404-.1864-.568-.3369s-.295-.3335-.385-.5373c-.089-.2037-.135-.4239-.135-.6465 0-.2227.046-.4428.135-.6466.09-.2038.221-.3867.385-.5372s.358-.2653.568-.337c.211-.0718.434-.0989.656-.0798h51.872c.222-.0191.445.008.656.0798.211.0717.404.1865.568.337.165.1505.295.3334.385.5372s.136.4239.136.6466c0 .2226-.046.4428-.136.6465-.09.2038-.22.3868-.385.5373-.164.1505-.357.2652-.568.3369-.211.0718-.434.099-.656.0798h-.059z",
    fill: "#353535"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m420.78 78.868h-51.812c-.211 0-.42-.0416-.615-.1223-.195-.0808-.372-.1991-.521-.3483-.149-.1491-.268-.3262-.348-.5211-.081-.195-.123-.4039-.123-.6148 0-.211.042-.4199.123-.6148.08-.1949.199-.372.348-.5212s.326-.2675.521-.3482c.195-.0808.404-.1223.615-.1223h51.872c.426 0 .835.1692 1.136.4705s.47.7099.47 1.136c0 .426-.169.8347-.47 1.1359-.301.3013-.71.4706-1.136.4706h-.06z",
    fill: "#353535"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m420.79 90.066h-51.813c-.222.0192-.445-.008-.656-.0797-.21-.0718-.404-.1865-.568-.337s-.295-.3335-.385-.5372c-.089-.2038-.135-.424-.135-.6466s.046-.4428.135-.6466c.09-.2038.221-.3867.385-.5372s.358-.2653.568-.337c.211-.0717.434-.0989.656-.0798h51.872c.222-.0191.445.0081.656.0798s.404.1865.568.337c.165.1505.295.3334.385.5372s.136.424.136.6466-.046.4428-.136.6466c-.09.2037-.22.3867-.385.5372-.164.1505-.357.2652-.568.337-.211.0717-.434.0989-.656.0797h-.059z",
    fill: "#353535"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m420.78 101.28h-51.812c-.211 0-.42-.042-.615-.122-.195-.081-.372-.199-.521-.349-.149-.149-.268-.326-.348-.521-.081-.195-.123-.4036-.123-.6145 0-.211.042-.4199.123-.6148.08-.1949.199-.372.348-.5212s.326-.2675.521-.3482c.195-.0808.404-.1223.615-.1223h51.872c.426 0 .835.1692 1.136.4705s.47.7099.47 1.136c0 .4265-.169.8345-.47 1.1355-.301.302-.71.471-1.136.471h-.06z",
    fill: "#353535"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m420.79 112.47h-51.813c-.222.019-.445-.008-.656-.08-.21-.071-.404-.186-.568-.337-.164-.15-.295-.333-.385-.537-.089-.204-.135-.424-.135-.646 0-.223.046-.443.135-.647.09-.204.221-.387.385-.537.164-.151.358-.265.568-.337.211-.072.434-.099.656-.08h51.872c.222-.019.445.008.656.08s.404.186.568.337c.165.15.295.333.385.537s.136.424.136.647c0 .222-.046.442-.136.646s-.22.387-.385.537c-.164.151-.357.266-.568.337-.211.072-.434.099-.656.08h-.059z",
    fill: "#353535"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m420.79 123.68h-51.813c-.222.019-.445-.008-.656-.08-.21-.071-.404-.186-.568-.337-.164-.15-.295-.333-.385-.537-.089-.204-.135-.424-.135-.646 0-.223.046-.443.135-.647.09-.204.221-.387.385-.537.164-.151.358-.265.568-.337.211-.072.434-.099.656-.08h51.872c.222-.019.445.008.656.08s.404.186.568.337c.165.15.295.333.385.537s.136.424.136.647c0 .222-.046.442-.136.646s-.22.387-.385.537c-.164.151-.357.266-.568.337-.211.072-.434.099-.656.08h-.059z",
    fill: "#353535"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m420.78 134.89h-51.812c-.211 0-.42-.042-.615-.123-.195-.08-.372-.199-.521-.348s-.268-.326-.348-.521c-.081-.195-.123-.404-.123-.615s.042-.42.123-.615c.08-.195.199-.372.348-.521s.326-.267.521-.348.404-.122.615-.122h51.872c.426 0 .835.169 1.136.47s.47.71.47 1.136-.169.835-.47 1.136-.71.471-1.136.471h-.06z",
    fill: "#353535"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m421.21 142.42h-53.538v61.416h53.538v-61.416z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.21 142.42h-53.538v61.416h53.538v-61.416z",
    fill: "white",
    opacity: 0.6,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.9 253.63c-.321-12.091.619-32.725-9.996-41.222-9.318-7.461-16.565 2.666-19.171 10.829-6.343 19.814-5.664 94.379-4.022 109.4 0 0-1.619-15.042-13.435-8.592-11.817 6.45 5.95 40.305 5.95 40.305s-13.971-10.21-20.421-1.618 8.068 18.278 8.068 18.278-13.435-3.76-13.435 0c0 3.761 4.296 6.986 16.66 8.604h66.64s10.71-5.95 8.604-12.364-13.483-2.701-13.483-2.701 17.196-20.956 16.113-30.095c-1.083-9.14-23.11 1.606-23.11 1.606s17.208-43.53 13.983-62.88c-2.547-15.243-14.376-4.76-20.813 1.048 1.513-10.125 2.138-20.362 1.868-30.595z",
    fill: "#FFC933",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.9 253.63c-.321-12.091.619-32.725-9.996-41.222-9.318-7.461-16.565 2.666-19.171 10.829-6.343 19.814-5.664 94.379-4.022 109.4 0 0-1.619-15.042-13.435-8.592-11.817 6.45 5.95 40.305 5.95 40.305s-13.971-10.21-20.421-1.618 8.068 18.278 8.068 18.278-13.435-3.76-13.435 0c0 3.761 4.296 6.986 16.66 8.604h66.64s10.71-5.95 8.604-12.364-13.483-2.701-13.483-2.701 17.196-20.956 16.113-30.095c-1.083-9.14-23.11 1.606-23.11 1.606s17.208-43.53 13.983-62.88c-2.547-15.243-14.376-4.76-20.813 1.048 1.513-10.125 2.138-20.362 1.868-30.595z",
    fill: "#FFC933",
    opacity: 0.1,
    style: {
      fill: "none"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m426.48 388.17 4.902-146.9",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.727
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m429.22 327.27 25.263-23.657",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.727
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m441.05 316.51 5.367-15.041",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.727
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m408.27 345.54 18.98 20.242",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.727
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m459.86 357.36-32.249 16.66",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.727
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m443.61 365.58 10.877.928",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.727
  })), /*#__PURE__*/React.createElement("path", {
    d: "m205.45 390.18c0 4.427-42.185 8.021-94.212 8.021s-94.224-3.57-94.224-8.021c0-4.45 42.186-8.02 94.224-8.02 52.039 0 94.212 3.593 94.212 8.02z",
    fill: "#286385",
    style: {
      fill: "#c73b24"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m64.331 242.87s7.2828-3.689 10.448-.523c3.1654 3.165 1.8921 37.033 2.8441 47.79.5768 6.416 1.7601 12.764 3.5343 18.957 0 0-10.448-1.892-18.362-5.95 0 0-6.9615-33.796 1.5351-60.274z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m209.33 319.57c-.857-.001-1.688-.292-2.358-.824-.671-.533-1.142-1.277-1.336-2.111s-.101-1.709.265-2.483c.366-.775.983-1.403 1.751-1.782l34.403-15.47 26.703-30.714c.649-.77 1.577-1.251 2.58-1.337s1.999.23 2.769.879 1.251 1.577 1.337 2.58-.23 1.999-.879 2.769l-27.215 31.321c-.326.4-.731.728-1.19.964l-35.129 15.815c-.527.267-1.111.402-1.701.393z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m232.86 306.16 3.773-1.713",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m215.46 314.07 14.911-6.783",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m266.45 276.22-9.936 11.233",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m254.91 289.06-2.249 2.559",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    d: "m213.92 333.21c4.208-17.748-6.768-35.547-24.516-39.755-17.748-4.209-35.547 6.768-39.756 24.516-4.208 17.748 6.768 35.547 24.516 39.755s35.547-6.768 39.756-24.516z",
    fill: "#3788B8",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74767,
    style: {
      fill: "#ffb6ae"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m99.235 203.35s4.7603 11.162 5.7593 13.34c1 2.178 1.952 2.773 1.726 3.463s-2.654 1.487-2.654 1.487c.337 3.435-.259 6.897-1.725 10.02-2.3804 4.76-7.0214 7.247-7.4736 10.234-.2664 2.872-.3062 5.761-.119 8.64l-7.021-5.76s1.9516-5.641.2261-9.782c-1.4629-3.389-4.0701-6.156-7.3661-7.818-4.1036-2.693-7.0237-6.852-8.1634-11.626-1.0353-5.534 2.1777-11.401 6.4379-15.542s12.662-3.332 13.59-2.987-2.3086-2.38.5712-2.998c2.8798-.619 4.6053 3.57 4.76 4.26s1.0353-2.987 1.9635-.571c.9286 2.415-.5117 5.64-.5117 5.64z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_645_2624",
    x: 72,
    y: 193,
    width: 35,
    height: 58,
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse"
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m99.235 203.35s4.7603 11.162 5.7593 13.34c1 2.178 1.952 2.773 1.726 3.463s-2.654 1.487-2.654 1.487c.337 3.435-.259 6.897-1.725 10.02-2.3804 4.76-7.0214 7.247-7.4736 10.234-.2664 2.872-.3062 5.761-.119 8.64l-7.021-5.76s1.9516-5.641.2261-9.782c-1.4629-3.389-4.0701-6.156-7.3661-7.818-4.1036-2.693-7.0237-6.852-8.1634-11.626-1.0353-5.534 2.1777-11.401 6.4379-15.542s12.662-3.332 13.59-2.987-2.3086-2.38.5712-2.998c2.8798-.619 4.6053 3.57 4.76 4.26s1.0353-2.987 1.9635-.571c.9286 2.415-.5117 5.64-.5117 5.64z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_645_2624)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.655 247.22c-.0416-.799-.133-1.594-.2737-2.38-.4641-2.095 2.38-8.616 3.2606-16.292.8806-7.675-5.1289-18.397-5.1289-18.397l-4.403-12.769c-1.9555.419-3.7657 1.347-5.2479 2.69-4.2602 4.141-7.4732 10.008-6.4379 15.541 1.1397 4.774 4.0598 8.933 8.1634 11.626 3.296 1.662 5.9032 4.43 7.3661 7.819 1.7255 4.141-.2261 9.782-.2261 9.782l2.9274 2.38z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae"
    }
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m99.235 203.35s4.7603 11.162 5.7593 13.34c1 2.178 1.952 2.773 1.726 3.463s-2.654 1.487-2.654 1.487c.337 3.435-.259 6.897-1.725 10.02-2.3804 4.76-7.0214 7.247-7.4736 10.234-.2664 2.872-.3062 5.761-.119 8.64l-7.021-5.76s1.9516-5.641.2261-9.782c-1.4629-3.389-4.0701-6.156-7.3661-7.818-4.1036-2.693-7.0237-6.852-8.1634-11.626-1.0353-5.534 2.1777-11.401 6.4379-15.542s12.662-3.332 13.59-2.987-2.3086-2.38.5712-2.998c2.8798-.619 4.6053 3.57 4.76 4.26s1.0353-2.987 1.9635-.571c.9286 2.415-.5117 5.64-.5117 5.64z",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m99.686 209.29s-2.0825-.572-2.7727 1.19c-.2168.403-.3391.85-.3577 1.308-.0185.458.0672.914.2506 1.333",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m102.11 226.83s-2.07 1.035-3.3435-.345",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m98.056 217.18-9.5914 4.153",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m84.455 226.38c-1.2949 1.907-1.8995 4.199-1.7136 6.497.2856 3.927.1904 9.282-1.8207 8.806s.952-6.509.952-8.996c-.1189-1.895-.5532-3.758-1.2852-5.51",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m105.05 214.16-2.261.975",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m101.35 216.4c.298 1.011.298 1.904 0 1.987-.297.083-.773-.667-1.071-1.678-.2973-1.012-.2854-1.904 0-1.999.286-.095.786.666 1.071 1.69z",
    fill: "#353535"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m102.56 216.4c.797 2.38.595 4.582-.452 4.939-1.048.357-2.547-1.297-3.3443-3.665s-.595-4.594.4522-4.951c1.0471-.357 2.5471 1.297 3.3441 3.677z",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m86.656 225.62s-1.8921-2.284-.1904-2.094c.5344.11 1.029.363 1.4313.732.4022.369.6972.84.8535 1.362",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m139.86 264.69-6.675 4.724 1.035 5.522 7.604-2.987-1.964-7.259z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m133.88 268.03 2.999 11.162s-20.183 9.211-24.169 12.055c-3.987 2.844-7.14 2.07-7.14 2.07l-2.642-12.899s2.868 1.38 8.972-1.262c6.105-2.642 21.98-11.126 21.98-11.126z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m143.79 297.08c-.406-.043-.783-.229-1.062-.526-.28-.298-.443-.685-.461-1.093l-2.666-44.161c-.027-.233-.005-.47.063-.695s.182-.433.335-.612c.152-.179.34-.325.551-.429.211-.103.441-.162.676-.173.235-.01.469.028.689.112.22.083.42.212.588.376.168.165.3.362.388.58.089.218.131.452.126.687l2.665 44.149c.011.225-.022.45-.098.662s-.193.407-.344.574c-.152.167-.335.303-.538.399-.204.096-.425.151-.65.162l-.262-.012z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m138.71 263.64c-.424-.018-.826-.193-1.128-.491-.303-.297-.484-.696-.51-1.12-.025-.423.108-.841.373-1.172.265-.332.644-.553 1.063-.621l6.676-.809c.231-.047.47-.045.701.005.231.049.449.146.64.285.192.138.353.314.473.517s.197.429.226.664c.029.234.009.472-.059.698-.067.227-.181.437-.333.617-.153.18-.341.327-.553.431-.212.105-.443.164-.679.175l-6.676.809-.214.012z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m139.05 267.09c-.424-.018-.826-.193-1.129-.49-.302-.298-.484-.697-.509-1.12-.025-.424.108-.842.373-1.173s.644-.552 1.062-.62l6.676-.81c.451-.05.904.079 1.26.36.356.28.588.69.644 1.14.027.222.01.447-.051.662-.06.215-.162.416-.3.592-.139.176-.31.322-.505.432-.195.109-.409.179-.631.206l-6.676.809-.214.012z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m139.42 270.23c-.418-.002-.82-.163-1.123-.45s-.486-.68-.51-1.097.111-.828.379-1.148c.268-.321.648-.527 1.063-.577l6.39-.774c.216-.028.435-.014.645.043.209.056.406.154.578.287.171.133.315.299.422.488.107.19.176.398.202.614.026.215.009.434-.05.643-.06.209-.16.405-.295.575s-.303.312-.493.416c-.191.105-.4.171-.616.195l-6.39.773-.202.012z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m140.49 273.24c-.329-.033-.634-.188-.854-.434-.22-.247-.34-.568-.336-.899-.066-.356 0-.725.187-1.036.186-.311.479-.543.825-.653l4.522-.726c.643-.084 1.19.5 1.285 1.333.072.357.008.728-.179 1.04s-.484.544-.832.649l-4.51.714-.108.012z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m138.04 267.8c-.02.325-.158.631-.388.861-.23.231-.536.369-.861.388-.352.097-.728.06-1.055-.102-.327-.163-.582-.44-.718-.778l-1.048-4.451c-.142-.631.393-1.249 1.19-1.392.351-.091.722-.051 1.046.11.323.162.578.436.716.77l1.059 4.463s.047.083.059.131z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m85.193 241.33s8.1753 4.951 11.971 11.162c3.7963 6.212 7.0213 15.47 8.8653 23.598 1.845 8.128 3.332 29.346 4.486 33.725.559 2.323 1.411 4.567 2.535 6.676-6.661 2.472-13.734 3.644-20.837 3.451-11.281-.465-13.007-3.225-13.007-3.225s-3.7961-25.086-3.451-45.006c.3451-19.921 9.4367-30.381 9.4367-30.381z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_645_2624",
    x: 75,
    y: 241,
    width: 39,
    height: 79,
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse"
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m85.193 241.33s8.1753 4.951 11.971 11.162c3.7963 6.212 7.0213 15.47 8.8653 23.598 1.845 8.128 3.332 29.346 4.486 33.725.559 2.323 1.411 4.567 2.535 6.676-6.661 2.472-13.734 3.644-20.837 3.451-11.281-.465-13.007-3.225-13.007-3.225s-3.7961-25.086-3.451-45.006c.3451-19.921 9.4367-30.381 9.4367-30.381z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_645_2624)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80.374 263.88s-1.1901 1.869-.2381-3.022c.7704-3.421 2.0246-6.715 3.7248-9.782l5.5811 6.283 3.4985.238-.9282 1.631 6.7473 4.188-3.201-3.772.226-5.76-5.4025 1.666s-3.4986-6.283-4.4268-8.33c-.6188-1.404 1.4518-2.594 2.9036-3.224-1.1764-.916-2.3998-1.77-3.6652-2.559 0 0-9.0917 10.472-9.4368 30.381-.2737 15.791 2.0587 34.819 3.0345 42.031l17.85-.988-16.267-48.981z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae"
    }
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m85.193 241.33s8.1753 4.951 11.971 11.162c3.7963 6.212 7.0213 15.47 8.8653 23.598 1.845 8.128 3.332 29.346 4.486 33.725.559 2.323 1.411 4.567 2.535 6.676-6.661 2.472-13.734 3.644-20.837 3.451-11.281-.465-13.007-3.225-13.007-3.225s-3.7961-25.086-3.451-45.006c.3451-19.921 9.4367-30.381 9.4367-30.381z",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m82.777 245.36 8.5205 10.234 4.4862-1.725-.226 5.759 6.783 8.176",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m77.541 267.06s.952 9.52 3.7961 11.781",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m78.111 277.32s1.19 3.57 4.1769 4.76",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m102.82 272.18-4.9381 1.904.7616 2.094 4.5575-1.713",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m136.12 308.04c-.408-.001-.803-.148-1.113-.414s-.514-.634-.577-1.038l-6.164-40.032c-.033-.222-.023-.45.031-.668.054-.219.151-.425.285-.606s.302-.334.495-.45c.192-.117.406-.194.629-.227.223-.034.45-.023.668.031.219.054.425.151.606.284.181.134.334.302.451.495.116.193.193.407.227.63l6.164 40.031c.065.449-.05.906-.319 1.272-.27.365-.673.609-1.121.68l-.262.012z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m99.234 203.35s1.3805-3.225.4641-5.64c-.9163-2.416-1.8445 1.261-1.9635.571s-1.8326-4.832-4.76-4.26c-2.9274.571.3451 3.344-.5712 2.998-.9164-.345-9.3297-1.19-13.59 2.987s-7.4732 10.008-6.4379 15.542c1.1398 4.774 4.0598 8.933 8.1634 11.626 2.154 1.105 4.0327 2.678 5.4978 4.605 1.2368-.993 2.3656-2.114 3.3678-3.344-.5983.191-1.233.239-1.8531.14-.62-.099-1.2082-.343-1.717-.711-1.8445-1.273-2.7607-4.95-.4521-6.795 2.3086-1.844 4.5339 2.345 4.5339 2.345 2.38 1.273 1.4875-2.071.5712-3.57-.9163-1.5.3451-3.118.6902-5.296s-2.6419-2.999-2.2968-5.188c.3451-2.19 10.353-6.01 10.353-6.01z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m93.69 204.9s-4.1769-2.094-6.8425 1.19c-2.6656 3.285-2.0825 8.747-4.1769 11.972-.4898.888-1.171 1.656-1.9942 2.249-.8233.593-1.768.995-2.7658 1.178",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m75.445 215.74c1.2581.135 2.5191-.228 3.5132-1.011.9941-.782 1.6423-1.923 1.8061-3.178.952-4.76 6.2713-11.59 11.602-11.781 5.3312-.19 4.9385 3.57 4.9385 3.57",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m121.45 281.95 3.332-2.19s2.88-5.296 3.106-5.641 7.259-3.796 7.83-3.332c.324.283.576.639.735 1.038.16.4.222.831.182 1.259-.227.583-1.036 1.19-1.036 1.738 0 .547.928 4.938.928 6.092 0 1.155-4.76 3.106-6.675 3.689-1.916.583-4.487.572-5.07 1.036l-1.606 1.261-1.726-4.95z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m82.777 258.71s-2.9869.798-1.9516 9.199c1.0353 8.402 9.4367 36.712 12.424 40.174 2.9869 3.463 32.13-15.886 32.13-15.886l-3.57-11.055s-19.682 7.711-21.289 8.056c-1.6065.345-6.2237-24.74-7.8302-27.846",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_645_2624",
    x: 80,
    y: 258,
    width: 46,
    height: 51,
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse"
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m82.777 258.71s-2.9869.798-1.9516 9.199c1.0353 8.402 9.4367 36.712 12.424 40.174 2.9869 3.463 32.13-15.886 32.13-15.886l-3.57-11.055s-19.682 7.711-21.289 8.056c-1.6065.345-6.2237-24.74-7.8302-27.846",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_645_2624)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124.84 290.59c-6.057 1.916-20.075 6.284-21.896 6.093-2.38-.226-3.0226-1.63-4.4268-3.486-1.4042-1.857-3.4867 5.581-5.355 6.283s-.4641-8.33.238-10.246-1.6303.94-1.6303.94-4.6529-9.52-6.9853-16.065c-1.4785-4.273-2.6439-8.648-3.4867-13.09l-.5236 1.285c-.263 1.843-.263 3.714 0 5.557 1.0353 8.402 9.4367 36.712 12.424 40.175s32.13-15.887 32.13-15.887l-.488-1.559z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae"
    }
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m82.777 258.71s-2.9869.798-1.9516 9.199c1.0353 8.402 9.4367 36.712 12.424 40.174 2.9869 3.463 32.13-15.886 32.13-15.886l-3.57-11.055s-19.682 7.711-21.289 8.056c-1.6065.345-6.2237-24.74-7.8302-27.846",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m100.51 289.2c-1.1738.759-2.1806 1.748-2.96 2.908-.7793 1.16-1.315 2.466-1.5744 3.839",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m96.164 291.76c-.7995.798-1.4305 1.749-1.8557 2.796-.4252 1.046-.6358 2.168-.6195 3.297",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "m66.497 301.11s-3.1654-10.555-2.7489-32.499 1.6898-24.05.6307-25.74-20.23 9.604-34.51 26.061c-9.0916 10.52-20.706 26.097-21.468 50.635-.6307 19.623 8.6989 35.486 14.554 39.877 10.127 7.592 23.955 7.068 25.43 7.068h141.32s9.068-3.165 11.174-11.388 9.282-31.654-5.688-59.714c-9.83-18.41-27.43-38.187-30.393-36.712-2.963 1.476-14.03 22.61-29.107 35.867-14.244 12.531-41.353 21.729-69.199 6.545z",
    fill: "#3788B8",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    style: {
      fill: "#ffb6ae"
    }
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m195.23 295.41c-2.107-3.927-4.558-7.914-7.14-11.746-8.259 2.845-28.965 11.341-40.46 28.311-9.866 14.565-3.309 37.675 17.255 54.537h24.835s9.068-3.165 11.174-11.4 9.27-31.642-5.664-59.702z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m199.76 339.81c-.222 2.062-.551 4.176-.988 6.342",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m192.69 299s8.556 14.744 7.461 36.247",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m63.142 363.52v-21.098c-11.008-3.57-18.112-7.807-24.74-11.781-9.52-5.7-16.184-21.063-11.71-31.012 4.1055-9.187 15.47-13.292 21.515-9.187 5.8997 3.877 11.992 7.452 18.255 10.71 0 0-3.1654-10.555-2.7489-32.498.4165-21.944 1.6898-24.05.6307-25.74s-20.23 9.603-34.51 26.061c-9.0559 10.484-20.67 26.061-21.432 50.599-.6307 19.623 8.6989 35.485 14.554 39.877 10.127 7.592 23.955 7.068 25.43 7.068h14.756v-2.999z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m12.889 323.7c.1077 2.598.386 5.186.833 7.747",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m46.909 258.81c-3.4272 3.07-8.5442 6.676-11.722 10.353-9.1035 10.52-21.539 25.549-22.324 50.087",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    d: "m96.032 363.98c0 11.602-17.85 12.661-39.984 12.661s-39.984-.428-39.984-12.661c0-16.898 17.85-33.32 39.984-33.32s39.984 16.422 39.984 33.32z",
    fill: "#3788B8",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    style: {
      fill: "#ffb6ae"
    }
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m56.001 330.65c-20.432 0-37.259 14.066-39.675 29.548 2.38 9.746 19.242 10.115 39.675 10.115s37.211-.904 39.663-10.186c-2.4038-15.458-19.218-29.477-39.663-29.477z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    d: "m199.41 365.22c0 10.508-16.208 11.472-36.2 11.472s-36.212-.381-36.212-11.472c0-15.291 16.208-30.19 36.212-30.19s36.2 14.899 36.2 30.19z",
    fill: "#3788B8",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    style: {
      fill: "#ffb6ae"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m163.21 335.03c-18.504 0-33.748 12.745-35.926 26.775 2.178 8.818 17.422 9.151 35.926 9.151 18.505 0 33.689-.821 35.915-9.223-2.226-13.994-17.446-26.703-35.915-26.703z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m304.16 240.08c-1.415-.529-2.562-1.599-3.189-2.973-.627-1.375-.683-2.942-.155-4.358l16.065-42.947c.262-.703.66-1.348 1.171-1.897.511-.55 1.125-.993 1.807-1.305.682-.313 1.42-.487 2.169-.515.75-.027 1.498.094 2.201.356.704.261 1.348.659 1.898 1.17.549.511.993 1.125 1.305 1.807.312.683.487 1.42.514 2.17.028.75-.093 1.498-.355 2.201l-16.065 42.947c-.262.705-.66 1.351-1.173 1.901s-1.129.993-1.814 1.304-1.424.483-2.176.507c-.751.024-1.5-.101-2.203-.368z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m322.66 197.54-9.02 23.705",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m279.72 305.53c-1.246-.465-2.389-1.171-3.363-2.077-.973-.906-1.759-1.996-2.311-3.206-.553-1.21-.862-2.517-.909-3.846-.047-1.33.168-2.656.633-3.902l22.932-61.321c.946-2.517 2.854-4.554 5.304-5.665 2.449-1.11 5.239-1.202 7.756-.255s4.555 2.855 5.665 5.304 1.202 5.239.255 7.756l-22.979 61.262c-.939 2.506-2.831 4.538-5.264 5.653s-5.208 1.221-7.719.297z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m364.84 79.642c-11.433-4.2752-23.876-5.0642-35.757-2.2673-11.881 2.7968-22.666 9.054-30.991 17.98-8.324 8.9263-13.815 20.12-15.778 32.167s-.309 24.405 4.752 35.512 13.301 20.464 23.68 26.888c10.379 6.423 22.429 9.625 34.628 9.2 12.198-.425 23.996-4.458 33.903-11.589 9.906-7.13 17.476-17.038 21.751-28.471 5.73-15.33 5.136-32.309-1.65-47.203-6.786-14.893-19.209-26.482-34.538-32.217zm-39.496 105.6c-9.452-3.537-17.643-9.797-23.537-17.989-5.895-8.191-9.228-17.947-9.578-28.033s2.299-20.049 7.611-28.629c5.312-8.581 13.049-15.394 22.233-19.577 9.184-4.1834 19.402-5.5497 29.363-3.9259 9.96 1.6237 19.216 6.1645 26.595 13.048 7.38 6.884 12.553 15.801 14.865 25.624 2.312 9.824 1.659 20.112-1.876 29.565-4.744 12.675-14.327 22.947-26.644 28.557-12.316 5.61-26.356 6.099-39.032 1.36z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m301.84 118.7c2.476-5.459 6.01-10.374 10.397-14.459 4.388-4.085 9.542-7.2598 15.164-9.3405",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m297.76 137.6c-.013-4.629.686-9.232 2.07-13.649",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m284.72 150.18c-3.073-14.154-.912-28.941 6.082-41.623 6.995-12.683 18.349-22.4 31.959-27.353 13.61-4.9526 28.554-4.8046 42.063.4166 13.51 5.2211 24.669 15.162 31.411 27.98",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m402.68 130.31c1.745 14.26-1.696 28.672-9.693 40.606-7.998 11.934-20.02 20.596-33.872 24.404-13.853 3.808-28.612 2.508-41.587-3.661-12.974-6.169-23.298-16.797-29.088-29.945",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m398.64 114.78c1.553 3.786 2.714 7.722 3.463 11.745",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m103.6 347.83c9.484 0 17.172-7.688 17.172-17.172 0-9.483-7.688-17.171-17.172-17.171-9.4833 0-17.171 7.688-17.171 17.171 0 9.484 7.688 17.172 17.171 17.172z",
    fill: "#353535"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m103.6 345.16c8.005 0 14.494-6.489 14.494-14.494s-6.489-14.494-14.494-14.494c-8.0053 0-14.495 6.489-14.495 14.494s6.4893 14.494 14.495 14.494z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m99.198 334.94c-.1258-.128-.1961-.301-.1961-.481 0-.181.0703-.354.1961-.482l3.9269-3.927c.129-.126.302-.197.482-.197s.353.071.482.197c.065.063.118.139.153.222.036.084.054.174.054.265s-.018.182-.054.265c-.035.084-.088.16-.153.223l-3.915 3.915c-.063.066-.139.118-.223.154-.0838.035-.1739.054-.265.054s-.1812-.019-.265-.054c-.0838-.036-.1596-.088-.2229-.154z",
    fill: "#353535"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m93.226 340.92c-.1171-.111-.2102-.245-.2739-.393s-.0965-.308-.0965-.469c0-.162.0328-.322.0965-.47s.1568-.282.2739-.393l5.593-5.593c.1113-.119.2458-.214.3952-.279.1495-.064.3106-.098.4735-.098.1628 0 .3244.034.4734.098.149.065.284.16.395.279.117.111.21.245.274.393s.097.308.097.47c0 .161-.033.321-.097.469s-.157.282-.274.393l-5.5927 5.593c-.1113.119-.2459.214-.3953.279s-.3106.098-.4734.098c-.1629 0-.324-.033-.4735-.098-.1494-.065-.2839-.16-.3952-.279z",
    fill: "#353535"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m113.91 330.9c1.045-1.043 1.756-2.373 2.045-3.82.289-1.448.142-2.949-.422-4.313-.565-1.364-1.521-2.53-2.748-3.35-1.228-.821-2.671-1.259-4.147-1.259s-2.919.438-4.146 1.259c-1.228.82-2.184 1.986-2.748 3.35-.565 1.364-.712 2.865-.423 4.313.289 1.447 1.001 2.777 2.045 3.82 1.399 1.396 3.295 2.181 5.272 2.181s3.873-.785 5.272-2.181z",
    fill: "#353535"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m112.48 329.46c.757-.759 1.272-1.726 1.48-2.778s.099-2.142-.312-3.133c-.411-.99-1.107-1.837-1.999-2.432-.892-.596-1.94-.913-3.013-.913-1.072 0-2.12.317-3.012.913-.892.595-1.588 1.442-1.999 2.432-.411.991-.52 2.081-.312 3.133s.723 2.019 1.48 2.778c.504.506 1.103.908 1.762 1.182.66.273 1.367.414 2.081.414.715 0 1.422-.141 2.081-.414.66-.274 1.259-.676 1.763-1.182z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m316.61 269.42c0 1.512-.601 2.962-1.67 4.031s-2.519 1.669-4.031 1.669h-40.186c-.77.035-1.538-.086-2.26-.356-.721-.27-1.381-.684-1.938-1.216s-1-1.172-1.303-1.881c-.303-.708-.459-1.47-.459-2.241 0-.77.156-1.533.459-2.241.303-.709.746-1.348 1.303-1.88.557-.533 1.217-.946 1.938-1.217.722-.27 1.49-.391 2.26-.356h40.186c1.51 0 2.958.599 4.027 1.665 1.068 1.067 1.67 2.513 1.674 4.023z",
    fill: "#3788B8",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    style: {
      fill: "#ffb6ae"
    }
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m292.56 273.36c1.748 0 3.165-1.417 3.165-3.165 0-1.749-1.417-3.166-3.165-3.166s-3.166 1.417-3.166 3.166c0 1.748 1.418 3.165 3.166 3.165z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    d: "m244.45 307.35c4.259 0 7.712-3.453 7.712-7.712 0-4.258-3.453-7.711-7.712-7.711-4.258 0-7.711 3.453-7.711 7.711 0 4.259 3.453 7.712 7.711 7.712z",
    fill: "#3788B8",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    style: {
      fill: "#ffb6ae"
    }
  }), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m247.34 299.64c.002-.572-.165-1.132-.482-1.609-.316-.477-.767-.85-1.295-1.071-.528-.22-1.11-.279-1.672-.169-.561.11-1.078.385-1.483.789-.406.404-.682.919-.795 1.48s-.056 1.143.163 1.672c.218.529.589.982 1.064 1.3.476.318 1.036.488 1.608.488.765 0 1.499-.303 2.041-.842.542-.54.848-1.273.851-2.038z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    d: "m270.72 277.28c4.259 0 7.711-3.453 7.711-7.711 0-4.259-3.452-7.712-7.711-7.712s-7.711 3.453-7.711 7.712c0 4.258 3.452 7.711 7.711 7.711z",
    fill: "#3788B8",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    style: {
      fill: "#ffb6ae"
    }
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m270.72 272.54c1.643 0 2.975-1.332 2.975-2.975s-1.332-2.975-2.975-2.975-2.975 1.332-2.975 2.975 1.332 2.975 2.975 2.975z",
    fill: "white",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_645_2624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.717 56.744v-7.8568h1.1247v6.8915h3.723v.9653h-4.8477z",
    fill: "#286385",
    style: {
      fill: "#9d1207"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.228 56.744-.568-1.6572h-3.0649l-.6074 1.6572h-1.2597l3.3461-7.9641h.2981l3.1043 7.9641h-1.2485zm-2.0582-5.9047-1.2766 3.4591h2.4463l-1.1697-3.4591z",
    fill: "#286385",
    style: {
      fill: "#9d1207"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.466 53.72v3.0247h-1.1247v-7.8568c.8511-.0357 1.3647-.0536 1.5409-.0536 2.392 0 3.588.7633 3.588 2.29 0 1.7662-1.0573 2.6493-3.1718 2.6493-.1275 0-.4049-.0178-.8324-.0536zm0-3.8667v2.9014c.4762.0357.7274.0536.7536.0536 1.3947 0 2.0921-.5238 2.0921-1.5714 0-.9582-.7442-1.4373-2.2327-1.4373-.1499 0-.3543.0179-.613.0537z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.764 55.779v.9654h4.9208v-.9654h-4.9208z",
    fill: "#286385",
    style: {
      fill: "#9d1207"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.764 54.051v.9117h3.8466v-.9117h-3.8466z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.764 52.27v.9654h4.9208v-.9654h-4.9208z",
    fill: "#286385",
    style: {
      fill: "#9d1207"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.789 50.606v.9117h3.8466v-.9117h-3.8466z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.764 48.888v.9653h4.9208v-.9653h-4.9208z",
    fill: "#286385",
    style: {
      fill: "#9d1207"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.593 56.744h-1.659v-7.8568c1.0573-.0357 1.734-.0536 2.0302-.0536 1.151 0 2.062.3343 2.7331 1.0029.6711.665 1.0067 1.5517 1.0067 2.66 0 2.8317-1.3704 4.2475-4.111 4.2475zm-.5343-6.8914v5.8725c.2512.0357.5624.0536.9336.0536.7873 0 1.4059-.2807 1.8558-.842.4499-.5649.6749-1.3479.6749-2.349 0-1.8592-.8755-2.7888-2.6263-2.7888-.105 0-.3843.0179-.838.0537z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.193 56.744v-7.8568h1.1247v7.8568h-1.1247z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.88 56.744-.568-1.6572h-3.0651l-.6073 1.6572h-1.2597l3.3461-7.9641h.298l3.104 7.9641h-1.248zm-2.058-5.9047-1.277 3.4591h2.446l-1.169-3.4591z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_645_2624"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(62.717 48.78)",
    width: 41.413,
    height: 7.9641,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBroEon);
export default __webpack_public_path__ + "static/media/search-broEON.898fd4f52972fbbe17b24c887f57a3da.svg";
export { ForwardRef as ReactComponent };